import { type MaintenanceChecklistField } from '@gb-ticket/shared-types';
import { type ReactNode } from 'react';

import { Label } from '@/components/ui/label';

type Props = {
  field: MaintenanceChecklistField;
  children: ReactNode;
};

export function ChecklistFieldShell({ field, children }: Props) {
  if (field.type === 'info') {
    return <>{children}</>;
  }
  return (
    <div className="space-y-1">
      <Label className="flex flex-col gap-0.5">
        <span>
          {field.label}
          {field.required ? ' *' : ''}
        </span>
        {field.helpText ? (
          <span className="text-xs font-normal text-muted-foreground">{field.helpText}</span>
        ) : null}
      </Label>
      {children}
    </div>
  );
}
